import { action, computed, makeAutoObservable, observable } from "mobx"
import OptionsIcon from "../icons/OptionsIcon"
import OptionModel from "./OptionModel"
import ProductModel from "../stores/ProductModel"
import { StoreClass } from "../stores/Store"



export default class StepModel{
    owner: StepModel
    store: StoreClass
    @observable id: Number
    @observable type: String 
    @computed get typeId() {
        return `${this.type}_${this.id}`;
    }
    @observable option_id: Number
    @observable group_id: Number
    @observable required: Boolean = false
    @observable options: OptionModel[]|ProductModel[] = []
    @observable components: StepModel[]  = []
    @observable stock: Boolean
    @observable value: Number | null
    @observable previewValue: Number | null
    @observable name: String
    @observable order: Number
    @observable active: Boolean = false
    @observable extra: Boolean = false
    @observable multiSelect: Boolean = false
    
    
   
    @observable stepGroup = {
        id: null,
        name: null,
        order: 0,
    };

    @computed get change_model_view (){
        return this.getAttribute('change_model_view', false);
    }
    @computed get prefix_option(){
        return this.getAttribute('prefix_option', 'pe');
    }
    @computed get prefix_value(){
        return this.getAttribute('prefix_value', 'pe');
    }

    @computed get componentOwner() {
        if(this.store && this.store.sortedStepsFlat){
            return this.store.sortedStepsFlat.find(
                (step) => step.components?.includes(this)
            );
        }
        return null;
    }

    constructor({store, owner, ...data}){
        makeAutoObservable(this);
        this.owner = owner
        this.store = store
        this.data = data
        this.extra = data.extra

        this.id = data.id
        this.option_id = data.option_id
        this.group_id = data.group_id
        this.name = data.name
        this.order = data.order
        this.value = data.value
        this.type = data.type
        this.stock = data.stock
        this.required = data.required
        this.multiSelect = data.type === 'select_safety_type'

        // if options have .width & .length sort them by length then by width
        // debugger;
        if(data.options && data.options.length > 0){
            
            data.options = data.options.sort((a:OptionModel, b:OptionModel) => {
                if (a.width && b.width && a.length && b.length) {
                    return (a.length * 10 + a.width) - (b.length * 10 + b.width);
                } else if (a.priority && b.priority) {
                    return a.priority - b.priority;
                } else if (a.order && b.order) {
                    return a.order - b.order;
                } else {
                    return 0;
                }
            });
        }

        this.options = data.options

   
   
        
        this.stepGroup = data.stepGroup
        this.components = data.components

        console.log(`StepModel ${this.name} created`, this);
    }

    @computed get stepNumber() {
        if (this.store) {
            var parent = this.store.sortedSteps.find(
                (step) => step.components?.includes(this)
            );
            if (parent) {
                return parent.stepNumber;
            }
            var index = this.store.sortedSteps.indexOf(this);
            return index + 1;
        }
        return 0;
    }

    @computed get selectedOption() {
        return this.options?.find((option) => option.valueId === this.value);
    }
    @computed get previewOption() {
        return this.options.find((option) => option.valueId === this.previewValue);
    }



    @computed get extraProductsOptions() {
        const store = this.store;
        switch (this.type) {
            case "mattress":
                return store.selectedMattress.map((m:ProductModel) => {
                    return {
                        id: m.id,
                        options: m.toOptions()
                    }
                });
                break;
            case "mattress_toppers":
                return store.selectedTopMattress.map((m:ProductModel) => {
                    return {
                        id: m.id,
                        options: m.toOptions()
                    }
                });
            break;
            case "select_safety_type":
                if (store.selectedSafetyProducts.length > 0) {
                    return store.selectedSafetyProducts
                        .filter(p => typeof p.toOptions === 'function')
                        .map(p => ({
                            id: p.id,
                            options: p.toOptions()
                        }));
                }
                return null;
            break;
        }
        return null;
    }

    @observable areOptionsFiltered = true
    @computed get filteredOptions(): Array<OptionModel> {
        if(this.areOptionsFiltered){
            // show onlu option with custom size true
            return this.options.filter(
                (option: OptionModel) => !option.custom_size
            );
        }

        return this.options;
    }
    @computed get hasFilteredOptions() {
        return this.options.some((option: OptionModel) => option.custom_size);
    }
    @action filterOptions(bool) {
        this.areOptionsFiltered = bool
    }

    getAttribute(name, _default = null){
        if(this.data.attributes && this.data.attributes[name] !== undefined){
            return this.data.attributes[name];
        }
        return _default;
    }

    @computed get optionsAvailable() {
        return this.options?.filter(
            (option: OptionModel) => option.isAvailable
        );
    }
    @computed get isValid() {
        if(this.required && this.optionsAvailable?.length > 0 && !this.selectedOption){
            return false;
        }

        if(this.type === 'select_safety_type') {
            return true;
        }

        if(this.type !== 'additional_mattress') {
            if(this.required === false && this.optionsAvailable?.length > 0 && !this.selectedOption){
                return false;
            }
        }

        
        return true;
    }

    @action reset(){
        this.store.updateOption(this.id, 0);
        if(this.type === 'additional_mattress'){
            this.store.selectAdditionalMattress({valueId: 0});
        }
    }

}